import { MAIN_FILTERS_WITH_SORT } from "../components/FilterSection/data/filtersList";
import { FilterState, filtersMap } from "./formatFilterState";

type FilterKey = (typeof MAIN_FILTERS_WITH_SORT)[number]["key"];

const updateFilterValueByKey = (
  key: FilterKey,
  value: string | string[] | null = "",
  filterState: FilterState,
) => {
  if (key) {
    // @ts-ignore
    const activeFilterType = filtersMap[key];

    const updatedCurrFilters = { ...filterState };

    if (key === "leaseDuration") {
      // Special case for lease duration as it requires two keys to be updated in reducer
      updatedCurrFilters["minLeaseDuration"] = value as string;
      updatedCurrFilters["maxLeaseDuration"] = value as string;
    } else {
      // @ts-ignore
      updatedCurrFilters[activeFilterType] = value;
    }
    return updatedCurrFilters as FilterState;
  }
  return filterState;
};

export default updateFilterValueByKey;
